import React, { useEffect } from 'react'

import { ErrorContainer, ErrorBox } from './ErrorStyled'
import Container from '../container/Container'
import SFXS from '../../assets/audios/audios'

interface ERROR_PROPS {
  text: string
  unBlur: boolean
  playAudio?: any
  audio?: any
}
export default ({ text, unBlur, audio }: ERROR_PROPS) => {
  const { volume, sound } = audio
  const { errorSFX } = SFXS
  errorSFX.volume = parseFloat(volume)
  useEffect(() => {
    if (sound) {
      errorSFX.load()
      errorSFX.play()
    }
  }, [sound])

  return (
    <ErrorContainer>
      <Container unBlur={unBlur}>
        <ErrorBox>
          <p>{text}</p>
        </ErrorBox>
      </Container>
    </ErrorContainer>
  )
}
